export default {
  agent: 'Agent',
  login: 'Login',
  logout: 'Logout',
  pause: 'Pause',
  resume: 'Resume',
};
